// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
import UserDropdown from './UserDropdown'

// ** Third Party Components
import { Moon, Sun } from 'react-feather'

// ** Reactstrap Imports
import UserGroupDropdown from './UserGroupDropdown'

// ** Custom Components
import { useMediaQuery } from 'react-responsive'
import CustomizerNavbar from '../../../../components/common/CustomizerNavbar'

import { useEffect, useState } from 'react'
import { NavItem, NavLink } from 'reactstrap'
import { getUserName, isMfgEmployee } from '../../../../auth/LoginUser.js'
import { ToastMessageError } from '../../../../components/common/ToastMessage.js'
import { fetchUserGroup } from '../../../../components/react-select/fetchUserGroup.js'
import { useSearchNotification } from '../../../../utility/hooks/react-query/useNotification.js'
import NotificationBell from './NotificationBell.js'
import { getMenu } from '../../../../utility/Utils.js'

const hasMfgM75ApprovalMenu = () =>
  isMfgEmployee() && getMenu()?.some((item) => Number(item.MENU_ID) === 613)

const getUrlParamSearch = () => {
  let params = ``
  params += `"EMPLOYEE_ID_REQUEST":"${getUserName()}"`
  params += `, "EXCLUDE_MFG_M75":${isMfgEmployee()}`

  params = `{${params}}`
  return params
}

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin, userGroup, setUserGroup, isFetchData, setIsFetchData } = props
  const isTabletOrMobile = useMediaQuery({
    query: process.env.REACT_APP_RESPONSIVE_TABLET_OR_MOBILE
  })
  const [totalNotification, setTotalnotification] = useState(0)
  const [menuLeaveNotification, setMenuLeaveNotification] = useState(0)
  const [menuFlexTimeNotification, setMenuFlexTimeNotification] = useState(0)
  const [menuTimeRecordNotification, setMenuTimeRecordNotification] = useState(0)
  const [menuMfgM75Notification, setMenuMfgM75Notification] = useState(0)

  const [isApprover, setIsApprover] = useState(false)

  useEffect(() => {
    const checkUserGroup = async () => {
      try {
        const groups = await fetchUserGroup('Approver')
        // console.log(groups);

        const found = groups.some((group) => group.USER_GROUP_NAME === 'Approver')
        setIsApprover(found)
      } catch (error) {
        console.error(error)
      }
    }

    checkUserGroup()
  }, [])

  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className="ficon" onClick={() => setSkin('light')} />
    } else {
      return <Moon className="ficon" onClick={() => setSkin('dark')} />
    }
  }

  const onSuccessSearchData = (data) => {
    setIsFetchData(false)
    if (data.data && data.data.Status == true) {
      const message = {
        title: 'Search Employee',
        message: data.data.Message
      }
      // console.log(data.data.ResultOnDb);

      const hasMfgM75Approval = hasMfgM75ApprovalMenu()
      const mfgM75Count = hasMfgM75Approval
        ? Number(data.data.ResultOnDb[0][0].TOTAL_COUNT_MFG_M75 || 0)
        : 0

      setTotalnotification(
        Number(data.data.ResultOnDb[0][0].TOTAL_COUNT_LEAVE) +
          mfgM75Count +
          Number(data.data.ResultOnDb[1][0].TOTAL_COUNT_FLEX_TIME) +
          Number(data.data.ResultOnDb[2][0].TOTAL_COUNT_TIME_RECORD)
      )
      setMenuLeaveNotification(Number(data.data.ResultOnDb[0][0].TOTAL_COUNT_LEAVE))
      setMenuFlexTimeNotification(Number(data.data.ResultOnDb[1][0].TOTAL_COUNT_FLEX_TIME))
      setMenuTimeRecordNotification(Number(data.data.ResultOnDb[2][0].TOTAL_COUNT_TIME_RECORD))
      setMenuMfgM75Notification(mfgM75Count)
    } else {
      const message = {
        title: 'Search Employee',
        message: data.data.Message
      }

      ToastMessageError(message)
    }
  }

  const onErrorSearchData = (error) => {
    setIsFetchData(false)

    const message = {
      title: 'Search SignIn',
      message: error.message
    }
    ToastMessageError(message)
  }

  const { isLoading, error, data, isSuccess, isFetching } = useSearchNotification(
    onSuccessSearchData,
    onErrorSearchData,
    getUrlParamSearch(),
    isFetchData
  )

  return (
    <ul className="nav navbar-nav align-items-center ms-auto">
      <IntlDropdown />
      <NavItem className="d-none d-lg-block">
        <NavLink className="nav-link-style">{!isTabletOrMobile && <CustomizerNavbar />}</NavLink>
      </NavItem>
      <ThemeToggler />
      {isApprover && (
        <li className="nav-item relative">
          <NotificationBell
            countLeave={menuLeaveNotification}
            countFlexTime={menuFlexTimeNotification}
            countTimeRecord={menuTimeRecordNotification}
            countMfgM75={menuMfgM75Notification}
            showMfgM75={hasMfgM75ApprovalMenu()}
            total={totalNotification}
          />
        </li>
      )}
      <UserGroupDropdown
        userGroup={userGroup}
        setUserGroup={setUserGroup}
        isFetchData={isFetchData}
        setIsFetchData={setIsFetchData}
      />
      <UserDropdown />
    </ul>
  )
}
export default NavbarUser
